export class DateTimePeriod {
    id: string | undefined;
    modifier: any | undefined;
    precision: any | undefined;
    dateTime: string| undefined;
    fromDateTime: string| undefined;
    toDateTime: string| undefined;
  
    constructor(payload?: any) {
      if (payload) {
        this.id = payload.id;
        this.modifier = payload.modifier;
        this.precision = payload.precision;
        this.dateTime = payload.dateTime;
        this.fromDateTime = payload.fromDateTime;
        this.toDateTime = payload.toDateTime;
      }
    }
  }